<script>
import Layout from '@/Shared/layout/default'
import { Link } from '@inertiajs/vue3'

export default {
//   Using a render function...
  layout: (h, page) => h(Layout, [page]),



//   Using shorthand syntax...
  layout: Layout,
}
</script>

<script setup>
defineProps({ user: Object, projects: Object, clients: Object})
</script>

<template>


</template>